import { render } from "./UserRemarkDialog.vue?vue&type=template&id=1d6def62"
import script from "./UserRemarkDialog.vue?vue&type=script&lang=js"
export * from "./UserRemarkDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__